import { ChevronRightSVG } from '@sbercloud/uikit-product-icons';
import { CardProduct } from '@sbercloud/uikit-product-site-cards';
import { Grid } from '@sbercloud/uikit-product-site-grid';
import { LayoutType } from '@sbercloud/uikit-product-utils/dist/esm/types/adaptive';
import { ButtonFunction } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import { useRouter } from 'next/navigation';
import React from 'react';

import { HeaderCardProduct } from '../../../../../../../layout/Header/components/HeaderCardProduct';
import { CategoryElement } from '../../../../types';
import styles from '../../styles.module.scss';
import { GRID_CONFIG } from './constants';

type SectionCatalogTabBodyItemProps = {
  elementList: CategoryElement;
  layoutType: LayoutType;
  platformFilter?: string;
  slugCategoryForQuery?: string;
  isLinkWithQuery?: boolean;
  // Todo: в будущем убрать
  isOldCard?: boolean;
  maxLength?: number;
  onClickButtonAdditionItems?: () => void;
};

export function SectionCatalogWithSearchTabBodyItem({
  elementList,
  layoutType,
  maxLength,
  onClickButtonAdditionItems,
  platformFilter,
  slugCategoryForQuery,
  isOldCard,
  isLinkWithQuery,
}: SectionCatalogTabBodyItemProps) {
  const router = useRouter();

  const queryHref = isLinkWithQuery
    ? `?${platformFilter ? `platform=${platformFilter}&` : ''}${
        slugCategoryForQuery ? `category=${slugCategoryForQuery}` : ''
      }`
    : '';

  const hrefButton = `/${elementList.id}${queryHref}`;

  const filteredArray = elementList.items.filter((_, index) =>
    maxLength ? index < maxLength : true,
  );

  const countAdditionalItems =
    maxLength && elementList.items.length > maxLength
      ? elementList.items.length - maxLength
      : 0;

  const labelButton = `Еще ${elementList.label.toLowerCase()} ${
    countAdditionalItems ? `(${countAdditionalItems})` : ''
  }`;

  const handleClickButtonAdditionItems = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    onClickButtonAdditionItems && onClickButtonAdditionItems();
    router.push(hrefButton);
  };

  return (
    <div className={styles.categoryTitle}>
      <div className={styles.labelBlock}>
        <Typography family="sans" purpose="title" size="m">
          {elementList.label}
        </Typography>
        <ButtonFunction
          label={labelButton}
          href={hrefButton}
          onClick={handleClickButtonAdditionItems}
          size="m"
          appearance="neutral"
          icon={<ChevronRightSVG />}
          iconPosition="after"
        />
      </div>
      <Grid
        className={styles.gridItemsContainer}
        columnsConfig={GRID_CONFIG}
        gap="l"
        layoutType={layoutType}
      >
        {filteredArray.map((item) =>
          isOldCard ? (
            <CardProduct
              className={styles.cardProduct}
              key={item.title}
              title={item.title}
              description={item.description}
              icon={item.icon}
              href={item.href ?? ''}
              layoutType={layoutType}
              outline
            />
          ) : (
            <HeaderCardProduct
              key={item.title}
              title={item.title}
              text={item.description}
              icon={(item.icon as { src: string; alt?: string }).src}
              link={item.href ?? ''}
              productTags={item.tags}
            />
          ),
        )}
      </Grid>
    </div>
  );
}
